import React, { useEffect, useRef, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import "./Dropdown.scss";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {
    Box,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import Iconify from "../iconify";
import Icon from "@mui/material/Icon";
import { useTheme } from "@emotion/react";
//import { useField } from "formik";

const CloseIcon =
    "https://imtbepublic.s3.ap-south-1.amazonaws.com/oldAssets/assets/images/icons/Modals_icons/Close.svg";

const Dropdown = (props) => {
    const [items, setItems] = useState(null);
    const [selectedItem, setSelectedItem] = useState("");
    const [showList, setShowList] = useState(false);
    const containerRef = useRef();
    const theme = useTheme();

    //const [field, meta] = useField(props);
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        if (props) {
            let itemsValue = props.items.map((i) => {
                if (i.id !== props.defaultVal) {
                    return { ...i, isSelected: false };
                } else {
                    //setSelectedItem({ ...i, isSelected: true });
                    setSelectedItem(i.id);
                    return { ...i, isSelected: true };
                }
            });
            //setSelectedItem(itemsValue?.[0]?.id || "");
            setItems(itemsValue);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [props.items]);

    useEffect(() => {
        if (props.autocomplete) {
            if (props.showDropdown) {
                setShowList(true);
            } else {
                setShowList(false);
            }
        }
    }, [props.showDropdown]);

    const handleSelectChange = (item) => {
        const itemValues = items.map((i) =>
            i.id === item.id
                ? { ...i, isSelected: true }
                : { ...i, isSelected: false }
        );
        setItems(itemValues);
        //setSelectedItem({ ...item, isSelected: true });
        setSelectedItem(item.id);
        // console.log(item.id)
        props.change(item.id);
    };

    const handleClickOutside = (event) => {
        if (
            containerRef.current &&
            !containerRef.current.contains(event.target)
        ) {
            setShowList(false);
            if (props.handleClickOutside) {
                console.log("handleing outside click in ");
                props.handleClickOutside();
            }
        }
    };

    const handleChange = (event) => {
        //setSelectedItem(event.target.value);
        let i;
        items.forEach((val) => {
            if (val.id === event.target.value) i = val;
        });
        console.log(i);
        handleSelectChange(i);
    };
    let label = {};
    if (props?.title) {
        label = {
            label: props?.title,
            labelId: props?.title,
        };
    } else {
        label = {
            displayEmpty: true,
            inputProps: { "aria-label": "Without label" },
        };
    }

    const InputBootstrap = (props) => {
        return <TextField />;
    };

    return (
        <FormControl
            fullWidth={props.isEnrollment ? false : true}
            size={props.size}
            style={{
                ...(props?.className?.includes("topDropdown") && {
                    width: "auto",
                    height: props.size === "small" ? "40px" : "48px",
                    position: "relative",
                }),
                ...props?.style,
            }}
            focused={props?.focused}
        >
            {props?.haveCancelCross && selectedItem && (
                <IconButton
                    style={{
                        position: "absolute",
                        right: "30px",
                        top: props.size === "small" ? "5px" : "13px",
                        zIndex: 1,
                        cursor: "pointer",
                    }}
                    onClick={(event) => {
                        event.stopPropagation();
                        setSelectedItem("");
                        props?.change("");
                        if (props?.onCancel) {
                            props?.onCancel();
                        }
                    }}
                >
                    <img src={CloseIcon} alt="cancel" />
                </IconButton>
            )}
            {selectedItem && (
                <InputLabel
                    sx={{ color: "red", backgroundColor: "white" }}
                    id={props.size === "small" ? "demo-select-small-label" : ""}
                >
                    {props?.title}
                </InputLabel>
            )}

            <Select
                //id={field.name}
                displayEmpty={true}
                labelId={
                    props.size === "small" ? "demo-select-small-label" : ""
                }
                id={props.size === "small" ? "demo-select-small" : ""}
                className={
                    //(showList ? "custom-dd active " : " custom-dd ") +
                    (props.disabled ? " not-allowed " : "") +
                    (props?.variant === "standard"
                        ? "standard-noborder "
                        : "") +
                    props.className
                }
                MenuProps={{
                    disableScrollLock: true,
                }}
                disabled={props.disabled}
                readOnly={props.readOnly || items?.length === 1}
                onChange={handleChange}
                value={selectedItem}
                autoFocus={props.autoFocus}
                sx={{
                    height: "100%",
                    width: "auto",
                    borderRadius: "12px",
                    "& fieldset": {
                        border: `1px solid var(--Components-Outline, #ecefff)`,
                    },
                    ...((props.readOnly || items?.length === 1) && {
                        backgroundColor: "transparent",
                    }),
                    "&.Mui-focused": {
                        backgroundColor:
                            props.readOnly || items?.length === 1
                                ? "transparent"
                                : "inherit",
                    },
                }}
                variant={props?.variant || "outlined"}
                InputProps={{
                    readOnly: props.readOnly ? true : false,
                }}
                // {...label}
                open={props.open && items && items.length > 0}
                onOpen={() => {
                    if (!props.disabled && items && items.length > 0) {
                        props?.onOpen && props.onOpen();
                    }
                }}
                onClose={() => {
                    if (props.setOpen) {
                        props.setOpen(false);
                    }
                }}
                {...(props?.isEnrollment && {
                    IconComponent: (props) =>
                        items && items.length > 1 ? (
                            <Box
                                {...props}
                                sx={{
                                    borderRadius: "50%",
                                    border: `1px solid var(--Components-Outline, #ecefff)`,
                                    height: "36px",
                                    width: "36px",
                                    right: "20px !important",
                                    top: "9px !important",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    transform: props.open
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 0.1s",
                                }}
                            >
                                <Iconify
                                    icon="material-symbols:keyboard-arrow-down"
                                    sx={{
                                        height: "20px",
                                        width: "20px",
                                    }}
                                />
                            </Box>
                        ) : null,
                })}
                renderValue={(selected) => {
                    if (selected.length === 0) {
                        return (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    textWrap: "nowrap",
                                    // padding: "10px 0px 10px 6px",
                                }}
                            >
                                {props?.title}
                            </Typography>
                        );
                    }
                    return (
                        <div
                            style={{
                                marginRight: props?.isEnrollment
                                    ? "8px"
                                    : "inherit",
                                // padding: "10px 0px 10px 6px",
                                display: "flex",
                                justifyContent: "space-between",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {props?.isEnrollment ? (
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {
                                        items?.find(
                                            (item) => item.id === selected
                                        )?.name
                                    }
                                </Typography>
                            ) : (
                                items?.find((item) => item.id === selected)
                                    ?.name
                            )}

                            {selected.tag ? (
                                <span
                                    className={`dropdownTag ${
                                        !props?.isEnrollment && "ml"
                                    } pr10 pl10`}
                                >
                                    {selected.tag}
                                </span>
                            ) : null}
                        </div>
                    );
                }}
            >
                {items &&
                    items.map((i) => (
                        <MenuItem
                            value={i.id}
                            key={i.id}
                            style={{
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                            }}
                        >
                            {i.name}
                            {i.tag ? (
                                <span
                                    className="dropdownTag ml fontSize_12 pr10 pl10"
                                    style={{
                                        wordWrap: "break-word",
                                        overflowWrap: "break-word",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    {i.tag}
                                </span>
                            ) : null}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
};

export default Dropdown;
